// extracted by mini-css-extract-plugin
export default {"emptyPlaceholder":"tptbPnbV9Z"};